import { gql } from '@lcs/shared/api';

export const deleteDeviceMutation = gql`
   mutation DeleteDevice($deviceId: UInt!) {
      deleteDevice(id: $deviceId)
   }
`;
